/**
 * ERP Coach / n2nai_erpcoach API — tách khỏi backend E-court (axios api.js: VITE_API_URL).
 * Override: VITE_ERPCOACH_API_URL trong .env
 */
let base = import.meta.env.VITE_ERPCOACH_API_URL || 'https://erpcoach.n2nai.io/api'
base = base.replace(/\/$/, '')
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && base.startsWith('http://')) {
  base = base.replace('http://', 'https://')
}
export const ERPCOACH_API_BASE_URL = base

/** Khóa video trong ERP Coach (ví dụ `youtube_cwtZSdYE7bo`). POST /chat cần khớp định dạng này. */
export function toErpcoachCoachStorageVideoId(raw: string): string {
  const v = raw.trim()
  if (!v) return v
  if (/^(youtube|vimeo|file)_/i.test(v)) return v
  return `youtube_${v}`
}
